import React from 'react';
import styles from './styles.module.scss';
import { Product } from 'bootstrap/data/product/Product';
import { PlanSelectType } from '../plansection/PlanSection.constants';
import { getFormattedTerm } from 'bootstrap/data/product/Product.utils';
import { useFeatures } from 'useFeatures';
import { monthlyRenewsPrice } from 'subscription/singleproduct/SingleProductPayment';

interface InfoNoteProps {
  product: Product;
  planType?: PlanSelectType;
  currencyCode?: string;
}

export const InfoNote: React.FC<InfoNoteProps> = ({
  product,
  planType,
  currencyCode,
}) => {
  const { isSingleSubscriptionWithTwoPlansFlow } = useFeatures();

  const getRenewPrice = () => {
    if (isSingleSubscriptionWithTwoPlansFlow) {
      if (planType === PlanSelectType.MONTH) {
        return product.getFormattedRenewsPrice(
          currencyCode,
          monthlyRenewsPrice,
        );
      }
    }
    return product.getFormattedRenewsPrice();
  };

  return (
    <div className={styles.container}>
      {!isSingleSubscriptionWithTwoPlansFlow && (
        <p className={styles.description}>
          After {getFormattedTerm(planType)} introductory offer ends, you will
          be automatically enrolled in our {product.getRenewPeriodAdverbName()}{' '}
          subscription at the price of {getRenewPrice()}. You will receive an
          email receipt each time your subscription renews. You can cancel your
          subscription anytime in your Account details in the app.
        </p>
      )}
      {isSingleSubscriptionWithTwoPlansFlow && (
        <p className={styles.description}>
          Renews automatically on a {product.getRenewPeriodAdverbName()} basis
          at {getRenewPrice()}. You will receive an email receipt each time your
          subscription renews. You can cancel your subscription anytime in your
          Account details in the app.
        </p>
      )}
    </div>
  );
};
